import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Goods from '@/components/Goods'
import Detail from '@/components/Detail'
import Allocation from '@/components/Allocation'
import ShoppingCart from '@/components/ShoppingCart'
import OrderDetail from '@/components/OrderDetail'
import Order from '@/components/Order'
import DemandCaseList from '@/components/DemandCaseList'
import DemandCaseDetail from '@/components/DemandCaseDetail'
import ServiceCaseList from '@/components/ServiceCaseList'
import ServiceCaseDetail from '@/components/ServiceCaseDetail'
import ServiceCaseAdd from '@/components/ServiceCaseAdd'
import CaseDetail from '@/components/CaseDetail'
import Pwdreset from '@/components/Pwdreset'
import Company from '@/components/Company'
import ShareList from '@/components/ShareList'
import ShareDetail from '@/components/ShareDetail'
import MyProject from '@/components/MyProject'
import MyProjectDetail from '@/components/MyProjectDetail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    }, {
      path: '/goods',
      name: 'Goods',
      component: Goods
    }, {
      path: '/detail',
      name: 'Detail',
      component: Detail
    }, {
      path: '/allocation',
      name: 'Allocation',
      component: Allocation
    }, {
      path: '/shoppingcart',
      name: 'ShoppingCart',
      component: ShoppingCart
    }, {
      path: '/order',
      name: 'Order',
      component: Order
    }, {
      path: '/orderdetail',
      name: 'OrderDetail',
      component: OrderDetail
    }, {
      path: '/demandcaselist',
      name: 'DemandCaseList',
      component: DemandCaseList
    }, {
      path: '/demandcasedetail',
      name: 'DemandCaseDetail',
      component: DemandCaseDetail
    }, {
      path: '/servicecaselist',
      name: 'ServiceCaseList',
      component: ServiceCaseList
    }, {
      path: '/servicecasedetail',
      name: 'ServiceCaseDetail',
      component: ServiceCaseDetail
    }, {
      path: '/servicecaseadd',
      name: 'ServiceCaseAdd',
      component: ServiceCaseAdd
    }, {
      path: '/casedetail',
      name: 'CaseDetail',
      component: CaseDetail
    }, {
      path: '/pwdreset',
      name: 'Pwdreset',
      component: Pwdreset
    }, {
      path: '/Company',
      name: 'Company',
      component: Company
    }, {
      path: '/sharelist',
      name: 'ShareList',
      component: ShareList
    }, {
      path: '/sharedetail',
      name: 'ShareDetail',
      component: ShareDetail
    }, {
      path: '/myproject',
      name: 'MyProject',
      component: MyProject
    }, {
      path: '/myprojectdetail',
      name: 'MyProjectDetail',
      component: MyProjectDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js